import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompanyDetailsRoutingModule } from './company-details-routing.module';
import { CompanyDetailsComponent } from './company-details.component';
import { SubProductsQuestionComponent } from './sub-products-question/sub-products-question.component';
import { SubProductsComponent } from './sub-products/sub-products.component';
import { SharedModule } from "app/shared/shared.module";


@NgModule({
  imports: [
    CommonModule,
    SharedModule, 
    CompanyDetailsRoutingModule
  ],
  declarations: [CompanyDetailsComponent,
                 SubProductsQuestionComponent,
                 SubProductsComponent],
  entryComponents: [SubProductsQuestionComponent]
})
export class CompanyDetailsModule { }



// WEBPACK FOOTER //
// ./src/app/company-details/company-details.module.ts